"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.BottomSheetType=void 0;var t;(function(e){e.BasketDeletion="BasketDeletion",e.CheckoutErrorHandling="CheckoutErrorHandling",e.ProductDeletion="ProductDeletion"})(t||(exports.BottomSheetType=t={}));
//# sourceMappingURL=BottomSheetType.js.map
